import PropTypes from 'prop-types';

const ToggleSchema = {
  toggle: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

export default { ToggleSchema };
